import React, { useLayoutEffect, useState } from "react";
import ReactSlider from "react-rangeslider";
import { selector, useSetRecoilState } from "recoil";

import "./VolumeCard.css";

import { currentPlaylist } from "./atoms";

import { Sequencer } from "./Sequencer";
import { historyPush } from "./HistoryMachine";
import { BasicTrackCard } from "./BasicTrackCard";

const volumeChanger = selector({
  key: "volumeChanger",
  get: () => null,
  set: ({ set, get }, track) => {
    const playlist = get(currentPlaylist);

    set(historyPush, playlist);

    const list = playlist.map((e) => (e.url === track.url ? track : e));

    set(currentPlaylist, list);

    Sequencer.changeVolume(track);
  },
});

function Slider({ onChange, value }) {
  const [volume, setVolume] = useState(value);

  useLayoutEffect(() => {
    setVolume(value);
  }, [value]);

  return (
    <div className="track-volume">
      <ReactSlider
        tooltip
        min={0}
        max={100}
        value={volume}
        onChange={(val, x) => {
          setVolume(val);
        }}
        onChangeComplete={() => onChange(volume)}
      />
    </div>
  );
}

export function VolumeCard({ track, color }) {
  const changeVolume = useSetRecoilState(volumeChanger);

  return (
    <BasicTrackCard track={track} color={color}>
      <Slider
        value={track.volume}
        onChange={(volume) => changeVolume({ ...track, volume })}
      />
    </BasicTrackCard>
  );
}
